import axios from "axios";

export const callExternalApi = async (options: any) => {
    try {
        const response = await axios(options.config);
        const { data } = response;

        return {
            data,
            error: null,
        };
    } catch (error: any) {
        if (axios.isAxiosError(error)) {
            const axiosError = error;

            const { response } = axiosError;
            const detail = axiosError?.response?.data?.detail;

            let message = "http request failed";

            if (response && response.statusText) {
                message = response.statusText;
            }

            if (axiosError.message) {
                message = axiosError.message;
            }

            if (response && response.data && response.data.message) {
                message = response.data.message;
            }

            return {
                data: null,
                error: {
                    message,
                    detail,
                },
            };
        }

        return {
            data: null,
            error: {
                message: error.message,
            },
        };
    }
};

